import React from 'react'

import Center from '../../../../components/helpers/Center'
import ErrorPanel from './ErrorPanel'
import FlexGrid from '../../../../components/structure/FlexGrid'
import ImportLoader, { useImport } from '../_load/ImportLoader'
import Loading from '../../../../packages/kiti/components/helpers/Loading'
import Panel from '../../../../components/structure/Panel'
import SuccessPanel from './SuccessPanel'

const ImportStatusPanel = ({ onRestartImporter }) => {
  const importRecord = useImport()

  if (importRecord.status === 'done') return <SuccessPanel />
  if (importRecord.status === 'error') return <ErrorPanel onRestartImporter={onRestartImporter} />

  return (
    <Panel flex={12} noMargin>
      <Center>
        <FlexGrid gutter={0.4}>
          <Loading />
        </FlexGrid>
      </Center>
    </Panel>
  )
}

const Wrapper = ({ importId, ...props }) => (
  <ImportLoader id={importId}>
    <ImportStatusPanel {...props} />
  </ImportLoader>
)

export default Wrapper
